import { FC } from "react";
import { Col, Container, Row } from "reactstrap";
import { toastError } from "../../../../../helpers/toast-helper";
import { useTotalsForUser } from "../../../../../common/hooks/api/device";
import { getResponseItemData } from "../../../../../helpers/response-helper";
import DashboardWidget from "../../../../../components/Common/dashboard-widget";

interface Props {
    userId: string | number;
}

const DevicesTotals: FC<Props> = ({ userId }) => {
    const { data: deviceTotalsResponse, isLoading } = useTotalsForUser(userId, {
        onError: () => {
            toastError("Can't fetch device total data");
        }
    });

    const { data } = getResponseItemData(deviceTotalsResponse);

    return (
        <Container fluid className="p-0">
            <Row>
                <Col lg={12} xl={6}>
                    <DashboardWidget
                        title="Total # of Machines"
                        totalCountDescr="Machines"
                        buttonName="See All Machines"
                        buttonLink="/machines"
                        totalCount={data?.totalDevices}
                        isLoading={isLoading}
                        withoutRecent
                    />
                </Col>
                <Col lg={12} xl={6}>
                    <DashboardWidget
                        title="Machines Online"
                        totalCountDescr="Machines"
                        buttonName="See All Machines"
                        buttonLink="/machines"
                        totalCount={data?.totalOnlineDevices}
                        isLoading={isLoading}
                        withoutRecent
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default DevicesTotals;
